// extracted by mini-css-extract-plugin
module.exports = {"scrollerBlock":"scrollerBlock_scrollerBlock__cpXnW"};